module.exports = __webpack_public_path__ + "img/bac-img.ec8ab4f7.png";